import { DateRangePicker, Select, SelectItem } from '@nextui-org/react'
import { I18nProvider } from '@react-aria/i18n'
import { useDashboard } from '../context/DashboardContext'
import { getLocalTimeZone, parseDate, today } from '@internationalized/date'

export default function Filters () {
  const {
    isLoading,
    dateRange,
    setDateRange,
    showRegionFilters,
    isTiRegion,
    regions,
    stores,
    selectedRegion,
    selectedStore,
    handleRegionChange,
    setSelectedStore
  } = useDashboard()

  return (
    <div className='flex items-center gap-3'>
      <I18nProvider locale='es-ES'>
        <DateRangePicker
          isDisabled={isLoading}
          visibleMonths={2}
          label='Rango de fechas'
          value={dateRange as any}
          onChange={(val) => { if (val) setDateRange(val as any) }}
          minValue={parseDate('2023-01-01') as any}
          maxValue={today(getLocalTimeZone()) as any}
          className='max-w-xs'
          variant='bordered'
          size='sm'
          classNames={{ inputWrapper: 'bg-white shadow-sm border-gray-100' }}
        />
      </I18nProvider>
      {showRegionFilters && (
        <>
          <Select
            label='Region'
            placeholder='Region'
            selectedKeys={selectedRegion ? [selectedRegion] : []}
            onChange={(e) => handleRegionChange(e.target.value)}
            isDisabled={isTiRegion || isLoading}
            className='w-[300px]'
            variant='bordered'
            size='sm'
            classNames={{ trigger: 'bg-white' }}
          >
            {regions.map((item: any) => {
              const value = String(item.id ?? item.region ?? item.name ?? item)
              const labelText = String(item.name ?? item.region ?? item)
              return (
                <SelectItem key={value} value={value} textValue={labelText}>
                  {labelText}
                </SelectItem>
              )
            })}
          </Select>
          <Select
            label='Tienda'
            placeholder='Tienda'
            selectedKeys={selectedStore ? [selectedStore] : []}
            onChange={(e) => setSelectedStore(e.target.value)}
            isDisabled={!selectedRegion || isLoading}
            className='w-[500px]'
            variant='bordered'
            size='sm'
            classNames={{ trigger: 'bg-white' }}
          >
            {stores.map((item: any) => {
              const value = String(item.id ?? item.id)
              const labelText = `${item.seller_store_number} - ${item.store}`
              return (
                <SelectItem key={value} value={value} textValue={labelText}>
                  {labelText}
                </SelectItem>
              )
            })}
          </Select>
        </>
      )}
    </div>
  )
}
